export default "__VITE_ASSET__CrHr$QzN__"